import { GraduationCap, Award, ScrollText } from "lucide-react";

/**
 * CertificateTemplate - Printable certificate component for completed courses
 * Used in HospiceAcademy for generating downloadable/printable certificates
 */
export default function CertificateTemplate({ 
  user, 
  courseTitle, 
  completionDate, 
  ceuCredits, 
  isELNEC, 
  certificateRef 
}) {
  return (
    <div 
      ref={certificateRef}
      className="bg-white p-8 border-8 border-double border-primary/30 rounded-lg"
      style={{ width: '800px', minHeight: '600px' }}
    >
      {/* Header */}
      <div className="text-center border-b-2 border-primary/20 pb-6 mb-6">
        <div className="flex items-center justify-center gap-3 mb-4">
          <GraduationCap className="w-12 h-12 text-primary" />
          {isELNEC && <ScrollText className="w-10 h-10 text-indigo-600" />}
        </div>
        <h1 className="text-3xl font-serif font-bold text-primary mb-2">
          Goodwin House Hospice Academy
        </h1>
        {isELNEC && (
          <p className="text-indigo-600 font-medium">
            ELNEC - End-of-Life Nursing Education Consortium
          </p>
        )}
        <p className="text-muted-foreground">Certificate of Completion</p>
      </div>

      {/* Body */}
      <div className="text-center py-8">
        <p className="text-lg text-muted-foreground mb-2">This certifies that</p>
        <h2 className="text-3xl font-serif font-bold text-foreground mb-4">
          {user?.name || "Staff Member"}
        </h2>
        <p className="text-lg text-muted-foreground mb-2">has successfully completed</p>
        <h3 className="text-2xl font-semibold text-primary mb-6">
          {courseTitle}
        </h3>
        
        {/* CEU Badge */}
        <div className="inline-flex items-center gap-2 bg-primary/10 rounded-full px-6 py-3 mb-6">
          <Award className="w-5 h-5 text-primary" />
          <span className="font-bold text-primary">{ceuCredits} CEU Credits Awarded</span>
        </div>

        <p className="text-muted-foreground">
          Completed on {new Date(completionDate).toLocaleDateString('en-US', { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
          })}
        </p>
      </div>

      {/* Footer */}
      <div className="flex justify-between items-end mt-12 pt-6 border-t border-primary/20">
        <div className="text-center">
          <div className="w-48 border-t-2 border-foreground mb-2"></div>
          <p className="text-sm text-muted-foreground">Program Director</p>
          <p className="font-medium">Goodwin House Hospice</p>
        </div>
        <div className="text-center">
          <img 
            src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='45' fill='none' stroke='%23666' stroke-width='2'/%3E%3Ctext x='50' y='55' font-family='serif' font-size='12' text-anchor='middle' fill='%23666'%3EOFFICIAL%3C/text%3E%3Ctext x='50' y='70' font-family='serif' font-size='10' text-anchor='middle' fill='%23666'%3ESEAL%3C/text%3E%3C/svg%3E" 
            alt="Official Seal"
            className="mx-auto mb-2"
          />
          <p className="text-xs text-muted-foreground">
            Certificate ID: {Math.random().toString(36).substr(2, 9).toUpperCase()}
          </p>
        </div>
        <div className="text-center">
          <div className="w-48 border-t-2 border-foreground mb-2"></div>
          <p className="text-sm text-muted-foreground">Date Issued</p>
          <p className="font-medium">{new Date().toLocaleDateString()}</p>
        </div>
      </div>
    </div>
  );
}
